import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import ModalVideo from "react-modal-video";

import { fetchAboutUs } from "../redux/actions/aboutUsAction";
import { useAppDispatch } from "../redux/hook";
import { getVideoId } from "../utils/utils";
import { useTranslation } from "react-i18next";

import "../../node_modules/react-modal-video/css/modal-video.css";

export default function About() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [isOpen, setOpen] = useState(false);
  const [aboutUsData, setAboutUsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadAboutUs = async () => {
      const aboutUs = await dispatch(fetchAboutUs());
      if (
        typeof aboutUs.payload === "string" ||
        aboutUs.payload === undefined
      ) {
        setLoading(false);
        // navigate(checkError(homeEdit.payload));
      } else {
        setLoading(false);
        setAboutUsData(aboutUs.payload[0]);
      }
    };
    loadAboutUs();
  }, [dispatch]);

  const video = useCallback(() => {
    if (aboutUsData.video !== undefined) {
      return (
        <ModalVideo
          channel="youtube"
          youtube={{ mute: 0, autoplay: 0 }}
          isOpen={isOpen}
          videoId={getVideoId(aboutUsData.video)}
          onClose={() => setOpen(false)}
        />
      );
    }
  }, [aboutUsData.video, isOpen]);

  if (loading) {
    return (
      <Box
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          top: "50%",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <div className="container relative md:pb-24 pb-16">
        <div className="grid md:grid-cols-12 grid-cols-1 items-center gap-6">
          <div className="lg:col-span-5 md:col-span-6">
            <div className="relative">
              <div className="relative flex justify-end">
                <img
                  src={
                    process.env.REACT_APP_API_URL +
                    "/wwwroot/images/" +
                    aboutUsData.image_file
                  }
                  className="lg:w-[400px] w-[280px] rounded-xl shadow dark:shadow-gray-700"
                  alt=""
                />
                <div className="absolute top-0 translate-y-2/4 start-0 text-center">
                  <Link
                    to="#!"
                    onClick={() => setOpen(true)}
                    className="lightbox h-20 w-20 rounded-full shadow-lg shadow-slate-100 dark:shadow-slate-800 inline-flex items-center justify-center bg-white dark:bg-slate-900 text-orange-600"
                  >
                    <i className="mdi mdi-play inline-flex items-center justify-center text-2xl"></i>
                  </Link>
                </div>
                {video()}
              </div>
              <div className="absolute md:-start-5 start-0 -bottom-16">
                <img
                  src={
                    process.env.REACT_APP_API_URL +
                    "/wwwroot/images/" +
                    aboutUsData.image_file_02
                  }
                  className="lg:w-[280px] w-[200px] border-8 border-white dark:border-slate-900 rounded-xl"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 md:col-span-6">
            <div className="lg:ms-5">
              <h6 className="text-orange-500 text-sm font-medium uppercase mb-2">
                {aboutUsData?.title}
              </h6>
              <h3 className="mb-4 md:text-2xl text-xl font-medium">
                {aboutUsData?.sub_title}
              </h3>

              <p className="text-slate-400 dark:text-white/60 max-w-xl">
                {aboutUsData?.content}
              </p>

              <div className="relative mt-8">
                <Link
                  to="/aboutus"
                  className="py-2 px-5 inline-flex items-center font-medium tracking-wide border align-middle duration-500 text-[15px] text-center bg-orange-500 hover:bg-orange-600 border-orange-500 hover:border-orange-600 text-white rounded-xl"
                >
                  {t("external.about_us.read_more")}{" "}
                  <i className="mdi mdi-arrow-right ms-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
